import MixAndMatch from './MixAndMatch';
export default MixAndMatch;